import { render, staticRenderFns } from "./AlertsTableRow.vue?vue&type=template&id=ea19b5c0&scoped=true&"
import script from "./AlertsTableRow.vue?vue&type=script&lang=ts&"
export * from "./AlertsTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsTableRow.vue?vue&type=style&index=0&id=ea19b5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea19b5c0",
  null
  
)

export default component.exports